import React, { useState } from 'react'
import { MdCancel } from 'react-icons/md'
import { RxHamburgerMenu } from 'react-icons/rx'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import logo from '../../logo.png'

export default function Navbar() {
  const [openSideNav, setOpenSideNav] = useState(false)
  const toggleNav = () => {
       setOpenSideNav(!openSideNav)
  }
  return (
    <div className=' lg:flex lg:flex-row justify-between  w-[100%]'>
      <div className='flex flex-row gap-[1em]'>
        
       <img className='h-[4em] w-[4em] object-cover  mx-auto' src={logo} alt=''></img>

    <p className="font-[Poppins] font-bold text-3xl lg:text-xl -ml-[2em] p-[1em] text-center ">RentHub</p>
      </div>
    
      <RxHamburgerMenu onClick={toggleNav} className='lg:hidden text-2xl absolute left-[.5em] top-[1.5em]'/>
   
   
    <div className='hidden lg:flex lg:flex-row  mt-[.25em]'>
           
      <p className="font-[Satoshi] font-bold text-base p-[1em]">Home</p>
      <HashLink to="/services" className="font-[Satoshi] font-bold text-base p-[1em]">Services</HashLink>
      <HashLink to="/about" className="font-[Satoshi] font-bold text-base p-[1em]">Contact Us</HashLink>
    </div>


{
  openSideNav?
    <div className='flex bg-green-500 text-white text-center lg:hidden flex-col mt-[.25em]'>
      <MdCancel onClick={toggleNav} className='text-2xl relative left-[90%] top-[.65em]'/>
    
      <p className="font-[Satoshi] font-bold text-base p-[1em] mt-[1em]">Home</p>
      <Link to="/auth/signin/" className="font-[Satoshi] font-bold text-base p-[1em]">Sign In</Link>
      <Link to="/auth/signup/" className="font-[Satoshi] font-bold text-base p-[1em]">Sign Up</Link>
        <HashLink to="/services" className="font-[Satoshi] font-bold text-base p-[1em]">Services</HashLink>
      <HashLink to="/about" className="font-[Satoshi] font-bold text-base p-[1em]">Contact Us</HashLink>
   
    </div>:''
}
    <div className='hidden lg:block mt-[.5em] mr-[4.5em] pt-[.25em] '>
     <Link to="/Auth/signin" className='text-white px-[.9em] -ml-[1em] py-[.5em] rounded-2xl font-[Satoshi] font-bold bg-green-500'>Sign in</Link>
        < Link to="/Auth/signup" className='text-black p-[.5em] font-bold font-[Satoshi]
        '>Sign up</Link>

    </div>
    </div>

  )
}


